var map = {
	"./delo.svg": "fc87",
	"./finance.svg": "8bc2",
	"./mediji.svg": "6acb",
	"./mobilnost.svg": "2bb0",
	"./osebno.svg": "de49",
	"./politika.svg": "7e34",
	"./potrosnja.svg": "794e",
	"./telekomunikacije.svg": "59b1",
	"./zaposlitvi.svg": "002f",
	"./zdravje.svg": "a880",
	"./zivljenjski_slog.svg": "9c6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e8a";